
import { css } from 'lit';
export default css`
:host {
  width: inherit;
}

.alphabet-card__wrapper {
  display: flex;
}

.alphabet-card__wrapper {
  flex-direction: column;
}

.alphabet-card__wrapper {
  border-bottom-width: 1px;
}

.alphabet-card__wrapper {
  --tw-border-opacity: 1;
  border-color: rgba(216, 216, 216, var(--tw-border-opacity));
}

.alphabet-card__wrapper {
  padding-top: 6rem;
  padding-bottom: 6rem;
}

@media (min-width: 1024px) {

  .alphabet-card__wrapper {
    display: grid;
  }
}

@media (min-width: 1024px) {

  .alphabet-card__wrapper {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.alphabet-card__letter {
  display: flex;
}

.alphabet-card__letter {
  font-weight: 900;
}

.alphabet-card__letter {
  text-transform: uppercase;
}

.alphabet-card__letter {
  --tw-text-opacity: 1;
  color: rgba(242, 242, 242, var(--tw-text-opacity));
}

.alphabet-card__letter {
    font-size: 100px
  }

@media (min-width: 1024px) {

  .alphabet-card__letter {
    grid-column: span 1 / span 1;
  }
}

@media (min-width: 1024px) {

.alphabet-card__letter {
      font-size: 325px
  }
    }

@media (min-width: 1024px) {

  .alphabet-card__letter span {
    margin-top: -2.5rem;
  }
}

@media (min-width: 1024px) {

  .alphabet-card__letter span {
    display: inline-block;
  }
}

@media (min-width: 1024px) {

.alphabet-card__letter span {
        height: 325px;
        line-height: 1
    }
      }

.alphabet-card__nav {
  grid-column: span 1 / span 1;
}

@media (min-width: 768px) {

  .alphabet-card__nav {
    display: flex;
  }
}

@media (min-width: 768px) {

  .alphabet-card__nav {
    flex-direction: row;
  }
}

@media (min-width: 1024px) {

  .alphabet-card__nav {
    grid-column: span 2 / span 2;
  }
}

@media (min-width: 768px) {

  .alphabet-card__list {
    margin-right: 3rem;
  }
}

.alphabet-card__link {
  grid-column: span 1 / span 1;
}

.alphabet-card__link {
  display: inline-block;
}

.alphabet-card__link {
  padding-bottom: 0.75rem;
}

.alphabet-card__link {
  font-size: 1.25rem;
}

.alphabet-card__link {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

.alphabet-card__link:hover {
  text-decoration: underline;
}

.alphabet-card__no-results {
  font-size: 1.25rem;
}
`;